import { render, staticRenderFns } from "./_add-dialog.vue?vue&type=template&id=2a8b2f43&scoped=true"
import script from "./_add-dialog.vue?vue&type=script&lang=js"
export * from "./_add-dialog.vue?vue&type=script&lang=js"
import style0 from "./_add-dialog.vue?vue&type=style&index=0&id=2a8b2f43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8b2f43",
  null
  
)

export default component.exports